import { RootState } from "../reducers";

export const getGeometrySelection = ({ geometrySelection }: RootState): RootState["geometrySelection"] =>
  geometrySelection;
